import classNames from "classnames";
import * as React from "react";
import { Box } from "~/sharedComponents/layout/Box";
import * as styles from "./Separator.less";

type Variant = "dash" | "solid";
type ColorScheme = "secondary" | "tertiary";
type Props = {
    variant?: Variant;
    colorScheme?: ColorScheme;
} & React.ComponentProps<typeof Box>;

export const Separator: React.FC<Props> = ({ variant = "solid", colorScheme = "tertiary", ...rest }) => (
    <Box className={classNames(styles.separator, styles[variant], styles[colorScheme])} {...rest} />
);
